// extracted by mini-css-extract-plugin
module.exports = {"sortWrap":"OjaLY"};